import { Language } from '@customer-portal/shared';

import { ProfileLanguageDto } from '../../dtos';

export class ProfileLanguageMapperService {
  static mapToProfileLanguageModel(dto: ProfileLanguageDto): Language {
    const portalLanguage = dto?.data?.portalLanguage;

    return portalLanguage as Language;
  }
}
